export const USA_ZIP_CODE_MASK = '99999';

export const SSN_MASK = '999-99-9999';

export const SSN_FREE_MASK = '9999';

export const PHONE_MASK = '999 999 9999';
